import { Manager } from "../types/api/center";

interface INameProps extends Partial<Pick<Manager, "surname" | "name" | "lastname">> {}

export const getFullName = ({ surname, name, lastname }: INameProps) =>
    !(surname ?? name ?? lastname) ? "Не указан" : `${surname || ""} ${name || ""} ${lastname || ""}`;
